<template>
  <div class='refund-apply' v-loading='loading'>
    <table class='native-table' v-if='!isApplyRefundFee'>
      <tr>
        <th>收费项目</th>
        <th>已缴金额</th>
        <th v-if='isRefundFee'>可退金额</th>
        <th style='width: 210px'>{{ isAddSupplyFee ? '补费金额' : '退费' }}</th>
      </tr>
      <tr>
        <td>学费</td>
        <td>{{ defData.class_fee }}</td>
        <td v-if='isRefundFee'>{{ defData.refund_info.refund_remains.class_fee_remains }}</td>
        <td>
          <el-input
            v-model='form.class_fee'
            @input="change('class_fee')"
            style='width: 180px'
            placeholder='金额'
          ></el-input>
        </td>
      </tr>
      <tr v-if='defData.insurance || isAddSupplyFee' class='other-td'>
        <td>保险费</td>
        <td>{{ defData.insurance }}</td>
        <td v-if='isRefundFee'>{{ defData.refund_info.refund_remains.insurance_remains }}</td>
        <td>
          <el-input v-model='form.insurance' @input="change('insurance')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr v-if='defData.material_fee || isAddSupplyFee' class='other-td'>
        <td>材料费</td>
        <td>{{ defData.material_fee }}</td>
        <td v-if='isRefundFee'>{{ defData.refund_info.refund_remains.material_fee_remains }}</td>
        <td>
          <el-input v-model='form.material_fee' @input="change('material_fee')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr v-if='defData.food_expenses || isAddSupplyFee' class='other-td'>
        <td>伙食费</td>
        <td>{{ defData.food_expenses }}</td>
        <td v-if='isRefundFee'>{{ defData.refund_info.refund_remains.food_expenses_remains }}</td>
        <td>
          <el-input v-model='form.food_expenses' @input="change('food_expenses')" placeholder='金额'></el-input>
        </td>
      </tr>
      <!--      <tr v-if="defData.accompanying_fee || isAddSupplyFee" class="other-td">
              <td>陪读费</td>
              <td>{{ defData.accompanying_fee }}</td>
              <td v-if="isRefundFee">{{ defData.refund_info.refund_remains.accompanying_fee_remains }}</td>
              <td>
                <el-input v-model="form.accompanying_fee" @input="change('accompanying_fee')" placeholder="金额"></el-input>
              </td>
            </tr>-->
      <!--      <tr v-if="defData.hosting_fee || isAddSupplyFee" class="other-td">
              <td>托管费</td>
              <td>{{ defData.hosting_fee }}</td>
              <td v-if="isRefundFee">{{ defData.refund_info.refund_remains.hosting_fee_remains }}</td>
              <td>
                <el-input v-model="form.hosting_fee" @input="change('hosting_fee')" placeholder="金额"></el-input>
              </td>
            </tr>-->
      <tr v-if='refund_type === 2 && (defData.accommodation_traffic_ticket || isAddSupplyFee)' class='other-td'>
        <td>食宿交通门票等</td>
        <td>{{ defData.accommodation_traffic_ticket }}</td>
        <td v-if='isRefundFee'>{{ defData.refund_info.refund_remains.accommodation_traffic_ticket_remains }}</td>
        <td>
          <el-input v-model='form.accommodation_traffic_ticket' @input="change('accommodation_traffic_ticket')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr>
        <td colspan='4' class='diy-td'>
          <strong
          >总额：<span>{{ total.total_fee || 0 }} 元</span>
          </strong>
        </td>
      </tr>
      <tr>
        <td colspan='4' class='diy-td'>
          <span class='red'>* </span>
          <strong>原因：</strong>
          <el-input v-model='supply_reason' placeholder='请填写原因' type='textarea' :rows='2'></el-input>
        </td>
      </tr>
      <tr v-if='!isAddSupplyFee'>
        <td colspan='4' class='diy-td'>
          <strong>是否保留名额：</strong>
          <el-radio :disabled="keep_reserved==='否'" v-model='is_reserved_quota' :label='true' border>是</el-radio>
          <el-radio :disabled="keep_reserved==='否'" v-model='is_reserved_quota' :label='false' border>否</el-radio>
        </td>
      </tr>
    </table>

    <table class='native-table' v-else>
      <tr>
        <th>补费项目</th>
        <th>补费金额</th>
        <th>剩余补费</th>
        <th style='width: 210px'>退费金额</th>
      </tr>
      <tr>
        <td>学费</td>
        <td>{{ defData.class_fee }}</td>
        <td>{{ defData.refund_info.refund_remains.class_fee_remains }}</td>
        <td>
          <el-input
            v-model='form.class_fee'
            @input="change('class_fee')"
            style='width: 180px'
            placeholder='金额'
          ></el-input>
        </td>
      </tr>
      <tr v-if='defData.insurance' class='other-td'>
        <td>保险费</td>
        <td>{{ defData.insurance }}</td>
        <td>{{ defData.refund_info.refund_remains.insurance_remains }}</td>
        <td>
          <el-input v-model='form.insurance' @input="change('insurance')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr v-if='defData.material_fee' class='other-td'>
        <td>材料费</td>
        <td>{{ defData.material_fee }}</td>
        <td>{{ defData.refund_info.refund_remains.material_fee_remains }}</td>
        <td>
          <el-input v-model='form.material_fee' @input="change('material_fee')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr v-if='defData.food_expenses' class='other-td'>
        <td>伙食费</td>
        <td>{{ defData.food_expenses }}</td>
        <td>{{ defData.refund_info.refund_remains.food_expenses_remains }}</td>
        <td>
          <el-input v-model='form.food_expenses' @input="change('food_expenses')" placeholder='金额'></el-input>
        </td>
      </tr>
      <!--      <tr v-if="defData.accompanying_fee" class="other-td">
              <td>陪读费</td>
              <td>{{ defData.accompanying_fee }}</td>
              <td>{{ defData.refund_info.refund_remains.accompanying_fee_remains }}</td>
              <td>
                <el-input v-model="form.accompanying_fee" @input="change('accompanying_fee')" placeholder="金额"></el-input>
              </td>
            </tr>-->
      <!--      <tr v-if="defData.hosting_fee" class="other-td">
              <td>托管费</td>
              <td>{{ defData.hosting_fee }}</td>
              <td>{{ defData.refund_info.refund_remains.hosting_fee_remains }}</td>
              <td>
                <el-input v-model="form.hosting_fee" @input="change('hosting_fee')" placeholder="金额"></el-input>
              </td>
            </tr>-->
      <tr v-if='defData.accommodation_traffic_ticket && refund_type === 2' class='other-td'>
        <td>食宿交通门票等</td>
        <td>{{ defData.accommodation_traffic_ticket }}</td>
        <td>{{ defData.refund_info.refund_remains.accommodation_traffic_ticket_remains }}</td>
        <td>
          <el-input v-model='form.accommodation_traffic_ticket' @input="change('accommodation_traffic_ticket')" placeholder='金额'></el-input>
        </td>
      </tr>
      <tr>
        <td colspan='4' class='diy-td'>
          <strong
          >总额：<span>{{ total.total_fee || 0 }} 元</span>
          </strong>
        </td>
      </tr>
      <tr>
        <td colspan='4' class='diy-td'>
          <strong>原因：</strong>
          <el-input v-model='supply_reason' placeholder='请填写原因' type='textarea' :rows='2'></el-input>
        </td>
      </tr>
    </table>

    <h3>表中价格单位：（元）</h3>
  </div>
</template>
<script>
import { Input, Radio } from 'element-ui';
import { finance, logger } from '@/api';
import pattern from '@/utils/pattern';

const Decimal = require('decimal.js');

export default {
  name: 'RefundApply',
  props: {
    refund_type: {
      type: Number,
      required: true
    },
    defData: {
      type: Object,
      required: true
    },
    method: {
      type: String,
      required: true
    },
    sign_up_id: {
      type: Number,
      required: true
    },
    keep_reserved: {
      type: String,
      required: true
    },
    number: {
      type: String
    }
  },
  components: {
    ElInput: Input,
    ElRadio: Radio
  },
  data() {
    return {
      form: {
        insurance: '',
        class_fee: '',
        material_fee: '',
        food_expenses: '',
        accompanying_fee: '',
        hosting_fee: '',
        accommodation_traffic_ticket: ''
      },
      refund_course_count: 0,
      supply_reason: '',
      is_reserved_quota: this.keep_reserved === '是',
      loading: false
    };
  },
  computed: {
    total() {
      const temp = {};
      let total_fee = 0;
      const isRight = Object.keys(this.form).every(key => {
        const value = this.form[key];
        if (value && pattern.decimal.test(value)) {
          temp[key] = Number(value);
          total_fee = Decimal.add(total_fee, temp[key]).toNumber();
          return true;
        }
        if (value && !pattern.decimal.test(value)) return false;
        temp[key] = 0;
        return true;
      });

      if (!isRight) {
        return {};
      }
      if (!total_fee) {
        return {};
      }
      return { temp, total_fee };
    },
    isAddSupplyFee() {
      // 是否补费申请
      return this.method === 'addSupplyFee';
    },
    isRefundFee() {
      // 是否退费申请
      return this.method === 'applyRefund';
    },
    isApplyRefundFee() {
      // 是否退补费申请
      return this.method === 'refundSupplyFee';
    },
    // 是否结课
    isOverClass() {
      if (this.defData.refund_info.is_over_class !== undefined) return !!this.defData.refund_info.is_over_class;
      return !!this.defData.refund_info.refund_phase;
    }
  },
  methods: {
    async refundApply() {
      if (!this.total.total_fee) {
        this.$message.warning('请填写正确的价格！');
        return false;
      }
      if (!this.supply_reason) {
        this.$message.warning('请填写申请原因！');
        return false;
      }
      this.loading = true;
      let res = {};
      if (this.isApplyRefundFee) {
        res = await finance[this.method]({
          params: {
            sign_up_id: this.sign_up_id,
            refund_supply_total_fee: this.total.total_fee,
            refund_supply_reason: this.supply_reason,
            refund_reason: this.supply_reason,
            is_reserved_quota: this.is_reserved_quota,
            refund_supply_class_fee: this.form.class_fee || 0,
            refund_phase: this.isOverClass,
            refund_supply_material_fee: this.total.temp.material_fee,
            refund_supply_insurance: this.total.temp.insurance,
            refund_supply_food_expenses: this.total.temp.food_expenses,
            refund_supply_accompanying_fee: this.total.temp.accompanying_fee,
            refund_supply_hosting_fee: this.total.temp.hosting_fee,
            refund_supply_accommodation_traffic_ticket: this.total.temp.accommodation_traffic_ticket
          },
          sign_up_id: this.sign_up_id,
          supply_fee_id: this.defData.id
        });
      } else {
        res = await finance[this.method]({
          params: {
            ...this.total.temp,
            sign_up_id: this.sign_up_id,
            total_fee: this.total.total_fee,
            supply_reason: this.supply_reason,
            refund_reason: this.supply_reason,
            is_reserved_quota: this.is_reserved_quota,
            class_fee: this.form.class_fee || 0,
            refund_phase: this.isOverClass
          },
          sign_up_id: this.sign_up_id,
          supply_fee_id: this.defData.id
        });
      }
      this.loading = false;
      if (res) {
        if (!this.isApplyRefundFee) {
          let params = {};
          if (this.isAddSupplyFee) {
            params = {
              module: 2,
              event_type: 4,
              cusp: `对预约号“${this.number}”进行补费申请，其中申请的补费金额：学费“${this.form.class_fee}”、保险费“${this.form.insurance}”、材料费“${this.form.material_fee}”、伙食费“${this.form.food_expenses}”，申请原因：“${this.supply_reason}”`,
              status: 1
            };
          } else {
            params = {
              module: 2,
              event_type: 5,
              cusp: `对预约号“${this.number}”进行退缴费，其中退费“${this.form.class_fee}”，申请原因：“${this.supply_reason}”，是否保留名额：“${this.is_reserved_quota ? '是' : '否'}”`,
              status: 1
            };
          }
          logger.fetchLoggerPost(params);
        }
        this.$message.success(res.msg || '申请成功！');
        return true;
      }
      return false;
    },
    change(key) {
      if (this.form[key] < 0) {
        this.form[key] = 0;
        return;
      }
      if (this.defData.refund_info.refund_remains[`${key}_remains`] <= this.form[key] && !this.isAddSupplyFee) {
        this.form[key] = this.defData.refund_info.refund_remains[`${key}_remains`];
      }
    }
  }
};
</script>
<style lang='less'>
.refund-apply {
  .diy-td {
    text-align: left;
    padding: 5px;

    strong {
      margin-right: 10px;

      > span {
        color: @danger;
      }
    }

    .el-input {
      width: 300px;
    }
  }

  .other-td .el-input {
    width: 180px;
  }
}
</style>
